<template lang="pug">
div(:class="$style.headerContainer")
  Block(
    v-for="(innerBlock, key) in block.innerBlocks"
    :key="`headerBlock${key}`"
    :block="innerBlock"
    :lazy="false")
  LazyRetrieveQuoteModal(
    v-if="$i18n.locale === 'en' && emailFormShow"
    @close-modal="toggleModal")
</template>

<script lang="ts">
import { defineComponent } from "vue"

export default defineComponent({
  name: "HomePageHeader",
  props: {
    block: {
      type: Object as () => Block,
      required: true
    }
  },
  data() {
    return {
      emailFormShow: false
    }
  },
  mounted() {
    const makeLinkTogglable = (link: Node) => {
      link.addEventListener("click", () => {
        this.toggleModal()
      })
    }
    const quoteLink = document.querySelectorAll(".quote-link")
    if (quoteLink && quoteLink.length) {
      quoteLink.forEach(makeLinkTogglable)
    }

    const buttons = document.querySelectorAll(".homepage-ctas .av-buttons")
    if (buttons && buttons.length) {
      buttons.forEach(button => {
        button.addEventListener("click", () => {
          this.sendHomePageCtaTrackingEvent()
        })
      })
    }
  },
  methods: {
    toggleModal() {
      this.emailFormShow = !this.emailFormShow
    },
    sendHomePageCtaTrackingEvent() {
      this.$snowplow.trackHomePageCtaClick()
    }
  }
})
</script>

<style lang="css" module>
:global(.homepage-header) > :global(.content) {
  @apply lg:pt-ds-lg;
}

.headerContainer {
  > :global(.av-group) {
    @apply flex flex-col w-full;

    :global(.av-paragraph) {
      @apply max-w-[500px];
    }

    > *:nth-child(1) {
      h1,
      h2 {
        @apply mb-0 text-rebrandLg;
      }

      p:nth-child(2) {
        @apply text-base mt-ds-sm mb-ds-sm;
      }
    }
  }

  :global(.tp-mobile-responsive-container) {
    @apply mt-ds-lg;
  }

  :global(.homepage-ctas) {
    /** display: flex comes via utility class in WordPress -- deadlines deadlines dealines!! */
    @apply flex-col items-center mt-ds-lg lg:mt-ds-ml;

    > p:nth-child(1),
    > p:nth-child(2) {
      @apply text-base underline cursor-pointer mt-ds-sm;
    }

    > p:nth-child(2) {
      @apply mt-ds-md;
    }
  }
}

@screen md {
  .headerContainer {
    > :global(.av-group) {
      > *:nth-child(1) {
        h1,
        h2 {
          @apply text-rebrand2xl;
        }

        > p:nth-child(2) {
          @apply text-rebrandMd my-ds-md;
        }
      }

      > *:nth-child(2) {
        @apply items-start;
      }

      > *:nth-child(3) {
        @apply mt-ds-lg;
      }
    }
  }
}

@screen lg {
  .headerContainer {
    > :global(.av-group) {
      @apply grid gap-x-ds-ml;
      grid-template-areas:
        "heading cards"
        "actions cards";
      grid-template-columns: 4fr 8fr;

      > :nth-child(1) {
        @apply self-end;
        grid-area: heading;

        p:nth-child(2) {
          @apply mb-0;
        }
      }

      > *:nth-child(2) {
        @apply items-start;
        grid-area: actions;

        > *:nth-child(3) {
          @apply mt-ds-xl;
        }

        :global {
          .av-buttons {
            @apply mt-ds-xl;
          }
        }
      }

      > *:nth-child(3) {
        @apply my-0;
        grid-area: cards;
      }
    }
  }
}

@screen xl {
  .headerContainer {
    > :global(.av-group) {
      > *:nth-child(1) {
        h1,
        h2 {
          @apply text-rebrand3xl;
        }
      }
    }
  }
}
</style>
